var site = site || {};

site.track = site.track || {};

(function ($, ServiceBus, Topics) {
  const setupSkincareQuiz = function () {
    var $formOptions = $('.mantle-form-options-field__item').find('.js-mantle-form__checkbox');
    var $firstOption = $('#mantle-form__checkbox--1001').closest('.js-mantle-form-checkbox');
    var $secondOption = $('#mantle-form__checkbox--1002').closest('.js-mantle-form-checkbox');
    var $thirdOption = $('#mantle-form__checkbox--1003').closest('.js-mantle-form-checkbox');
    var $vtoSkinCareQuestion = $('.skincare-question-screens');
    var $surveyCtaQ1 = $vtoSkinCareQuestion.find('[data-field-name="question_screen01"]').find('.js-mantle-cta-button');
    var defaultSurveyId = parseInt($('.js-vto-skin-care-formatter').attr('data-default-survey-id'), 10) || 1005;

    $formOptions.once().on('click', function () {
      var $this = $(this);

      $this.closest('.js-form-formatter__item').find('.js-mantle-form__checkbox').removeClass('option-selected').addClass('options-unselected');
      $this.addClass('option-selected');
    });

    $('.js-form-formatter').find('.js-mantle-cta-button').once().on('click', function () {
      var $vtoSkinCareQuestion1 = $vtoSkinCareQuestion.find('[data-field-name="question_screen01"]').find('.js-mantle-form-checkbox.option-selected');
      var surveyIdQ1 = parseInt($vtoSkinCareQuestion1.find('.js-adpl-active').val(), 10);
      var $vtoSkinCareQuestionWrapper2 = $vtoSkinCareQuestion.find('[data-field-name="question_screen02"]');
      var $vtoSkinCareQuestion2 = $vtoSkinCareQuestionWrapper2.find('.js-mantle-form-checkbox.option-selected');
      var surveyIdQ2 = $vtoSkinCareQuestion2.length > 0 ? parseInt($vtoSkinCareQuestion2.find('.js-adpl-active').val(), 10) : defaultSurveyId;

      if ($(this).attr('data-trigger-type') === 'next') {
        $vtoSkinCareQuestionWrapper2.find('.js-mantle-cta-button').addClass('button--disabled');

        return;
      }
      window.YMK.setSurveyResult([surveyIdQ1, surveyIdQ2], true);
      $('.js-elc-vto-skin-care').addClass('elc-vto-skin-care--active');
      $('.skincare-question-wrapper').addClass('hidden');
      $('.js-skin-care-result-cta-wrapper').find('.elc-skin-care-result-cta').trigger('click');
    });

    $firstOption.add($secondOption).on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $surveyCtaQ1.attr('data-trigger-type', 'submit').removeClass('button--disabled');
    });

    $thirdOption.on('click', function (e) {
      var isSkinTypeHidden = $(this).closest('.js-skincare-question-wrapper').hasClass('js-hide-skin-type');
      var triggerType = isSkinTypeHidden ? 'submit' : 'next';

      e.preventDefault();
      e.stopPropagation();
      $surveyCtaQ1.attr('data-trigger-type', triggerType).removeClass('button--disabled');
    });
  };
  const updateImage = function () {
    var $skincareFormatter = $('.js-vto-skin-care-formatter');
    var $productBrief = $skincareFormatter.find('.js-product-brief');

    $productBrief.each(function() {
      var $this = $(this);
      var thisImg = $this.attr('data-medium-img');
      var $updatedImg = $this.find('.js-updated-img');

      if ($updatedImg.length > 0) {
        $updatedImg.prop('src', thisImg);
      } else {
        $this.find('.js-product-images-wrapper').prepend('<img class="updated-img js-updated-img" src="' + thisImg + '" />');
      }
    });
  };
  const updatePrice = function () {
    var $priceRangeWrapper = $('.js-product-price-range-row-wrapper');

    $priceRangeWrapper.each(function() {
      var $thisPrice = $(this);
      var originalPrice = $thisPrice.attr('data-price');
      var formattedPrice = $thisPrice.attr('data-formatted-price');

      if (!formattedPrice || originalPrice === formattedPrice) {
        $thisPrice.children('.js-product-price-range').text(originalPrice);
      } else {
        $thisPrice.children('.js-product-price-range').html(formattedPrice + '<span>' + originalPrice + '</span>');
      }
    });
  };
  const handleSkinCareResults = function () {
    var $skincareFormatter = $('.js-vto-skin-care-formatter');
    var nonNutritiousHeaderCopy = $skincareFormatter.find('.js-non-nutrious-header').html();
    var nutritiousHeaderCopy = $skincareFormatter.find('.js-nutrious-header').html();
    var yourAnalysisCopy = $skincareFormatter.find('.js-your-analysis').text();
    var productTabSimpleCopy = $skincareFormatter.find('.js-product-tab-simple').text();
    var productTabFullCopy = $skincareFormatter.find('.js-product-tab-full').text();
    var linesWrinclesCopy = $skincareFormatter.find('.js-lines-wrinkles').text();
    var darkSpotCopy = $skincareFormatter.find('.js-dark-spots').text();
    var unevenTextureCopy = $skincareFormatter.find('.js-uneven-texture').text();
    var rednessCopy = $skincareFormatter.find('.js-irritation-redness').text();
    var eyeLinesCopy = $skincareFormatter.find('.js-eye-lines').text();
    var darkCircleCopy = $skincareFormatter.find('.js-dark-circles').text();
    var benefitSequence = $skincareFormatter.attr('data-benefits-sequence')?.split(',');
    var skinConcernsString = $('.js-elc-vto-skin-care').attr('data-vto-skinconcern');
    var skinConcerns = JSON.parse(skinConcernsString);
    var $elcVtoSkincareProductGrid = $('.elc-vto-skincare-product-grid');
    var $skinCareTabItemFull = $('.js-skin-care-tab-item-full');
    var $skinCareTabItemSimple = $('.js-skin-care-tab-item-simple');
    var $skinCareResultNonNutritiousHeader = $('.js-skin-care-result-non-nutritious-header');
    var $skinCareResultNutritiousHeader = $('.js-skin-care-result-nutritious-header');
    var $skinCareYourAnalysis = $('.js-skin-care-your-analysis');
    var $vtoSkincareResultCta = $('.js-skin-care-result-cta-container');
    var $vtoSkincareResultTitle = $('.js-skin-care-result-title');
    var $vtoSkincareTabContent = $('.js-skin-care-tabs');
    var $vtoSkinCareQuestion2 = $('.skincare-question-screens').find('[data-field-name="question_screen02"]');
    var isSixthQuesActive = $vtoSkinCareQuestion2.find('#mantle-form__checkbox--1006').closest('.js-mantle-form__checkbox').hasClass('active');
    var vtoProdResultsString = $('.js-elc-vto-skin-care').attr('data-vto-prod-results');
    var vtoProdResults = JSON.parse(vtoProdResultsString);
    var perfectionistId = $skincareFormatter.attr('data-perfectionist-id')?.split(',');
    var reNutriveProducts = [];
    var simpleRegimeProds = [];
    var blueLineProduct = [];
    var nutritiousProduct = [];
    var faceConcerns = {};
    var eyeConcerns = {};
    var faceConcernKeys = [];
    var eyeConcernKeys = [];
    var sortedFaceConcerns = [];
    var sortedEyeConcerns = [];
    var selectedFaceConcern = [];
    var selectedEyeConcern = '';
    var selectedFaceConcernCopy = [];
    var selectedEyeConcernCopy =  '';
    var isUnEvenTexture = false;
    var hasRedness = false;
    var isNutritious = false;
    var setBenefitType;
    var arrangeBrief;
    var disconnectObserver;
    var observer;
    var $productGrid = $('.elc-service-view-renderer')[0];
    var $productBrief = $();
    var isObserverDisconnected = false;
    var mutationConfig = {
      childList: true,
      subtree: true
    };
    var faceConcernSeparator = Drupal?.settings?.vto_face_concern_separator || ',';

    function onMutationChangeCallack(mutationConfigList) {
      for (const mutationConfigItem of mutationConfigList) {
        $productBrief = $('.js-product-brief-view').find('.js-product-brief');
        if ((mutationConfigItem.type === 'childList' || mutationConfigItem.type === 'subtree') && $productBrief.length > 0) {
          $skinCareTabItemSimple.trigger('click');
        }
      }
    }

    observer = new MutationObserver(onMutationChangeCallack);
    observer.observe($productGrid, mutationConfig);

    $skinCareResultNonNutritiousHeader.html(nonNutritiousHeaderCopy);
    $skinCareResultNutritiousHeader.html(nutritiousHeaderCopy);
    $skinCareTabItemSimple.text(productTabSimpleCopy);
    $skinCareTabItemFull.text(productTabFullCopy);
    $skinCareYourAnalysis.text(yourAnalysisCopy);

    faceConcerns.redness = rednessCopy;
    faceConcerns.texture = unevenTextureCopy;
    faceConcerns.lines_and_wrinkles = linesWrinclesCopy;
    faceConcerns.spot = darkSpotCopy;
    eyeConcerns.wrinkle_eyes = eyeLinesCopy;
    eyeConcerns.dark_circle = darkCircleCopy;
    faceConcernKeys = Object.keys(faceConcerns);
    eyeConcernKeys = Object.keys(eyeConcerns);
    skinConcerns.forEach(function (item) {
      if (faceConcernKeys.includes(item[0])) {
        sortedFaceConcerns.push(item[0]);
      } else if (eyeConcernKeys.includes(item[0])) {
        sortedEyeConcerns.push(item[0]);
      }
    });
    selectedFaceConcern = sortedFaceConcerns.slice(0,2);
    selectedEyeConcern = sortedEyeConcerns[0];
    selectedFaceConcernCopy = selectedFaceConcern.map(item => faceConcerns[item]);
    selectedEyeConcernCopy =  eyeConcerns[selectedEyeConcern];
    isUnEvenTexture = selectedFaceConcernCopy?.includes(unevenTextureCopy);
    hasRedness = selectedFaceConcernCopy?.includes(rednessCopy);
    isNutritious = isSixthQuesActive && isUnEvenTexture && hasRedness;

    $('#discover-re-nutrive').closest('.js-content-formatter--v1').addClass('hidden');
    $vtoSkincareResultCta.add($vtoSkincareResultTitle).add($vtoSkincareTabContent).addClass('active');
    disconnectObserver = function () {
      if (isObserverDisconnected) {
        return;
      }
      observer.disconnect();
      isObserverDisconnected = true;
    };

    setBenefitType = function () {
      vtoProdResults.forEach(function (item) {
        if (item?.productLine === 'renutriv') {
          reNutriveProducts.push(item.productId);
        } else if (item?.productLine === 'blueline') {
          blueLineProduct.push(item.productId);
        } else if (item?.productLine === 'nutritious') {
          nutritiousProduct.push(item.productId);
        }
        if (item?.regimen?.includes('simple')) {
          simpleRegimeProds.push(item.productId);
        }
      });
      $elcVtoSkincareProductGrid.find('.js-product-brief').each(function () {
        var $this = $(this);
        var thisProductId = $this.attr('data-product-id');
        var thisBenefitTypeText = $this.find('.js-product-benefit-type').text();

        $this.attr('data-benefit-type', thisBenefitTypeText);
        if (simpleRegimeProds?.includes(thisProductId)) {
          $this.addClass('simple-regimen-product');
        }
        if (reNutriveProducts?.includes(thisProductId)) {
          $this.addClass('re-nutrive-product');
          $('body').addClass('skincare-re-nutriv-product');
          $('#discover-re-nutrive').closest('.js-content-formatter--v1').removeClass('hidden');
        } else if (blueLineProduct?.includes(thisProductId)) {
          $this.addClass('blue-line-product');
        } else if (nutritiousProduct?.includes(thisProductId)) {
          $this.addClass('nutritious-product');
        }
      });
      if ($elcVtoSkincareProductGrid.find('.js-product-brief').length > 0) {
        $elcVtoSkincareProductGrid.addClass('benefit-type-updated');
        disconnectObserver();
      }
    };

    setBenefitType();

    arrangeBrief = function () {
      var $thisBrief = $();
      var stepCount = 1;
      var $thisBenefitType = $();
      var thisBenefitTypeText = '';
      var thisBenefitHeader = '';
      var thisBenefitCategory = '';
      var $sameCategoryBriefs = $();
      var isStepAlreadySet = false;

      if (!$elcVtoSkincareProductGrid.hasClass('benefit-type-updated')) {
        setBenefitType();
      }

      vtoProdResults = vtoProdResults.sort((a, b) => {
        return benefitSequence.indexOf(a.category) - benefitSequence.indexOf(b.category);
      });
      $elcVtoSkincareProductGrid.find('.js-product-brief').each(function () {
        var $this = $(this);
        var thisProductId = $this.attr('data-product-id');
        var thisIndex = vtoProdResults.map((item) => item.productId).indexOf(thisProductId);
        var thisBenefitCategory = vtoProdResults[thisIndex]?.category;

        $this.parent('.js-grid-item-product').addClass('skincare-brief-order--' + thisIndex);
        $this.attr('data-benefit-category', thisBenefitCategory).removeClass('skip-step-count step-added');
      });
      for (let i = 0; i <= vtoProdResults.length; i++) {
        $thisBrief = $elcVtoSkincareProductGrid.find('.skincare-brief-order--' + i).children('.js-product-brief');
        thisBenefitCategory = $thisBrief.attr('data-benefit-category');
        $sameCategoryBriefs = $elcVtoSkincareProductGrid.find('[data-benefit-category="' + thisBenefitCategory + '"]');
        isStepAlreadySet = $sameCategoryBriefs.hasClass('step-added');

        if (!$thisBrief.hasClass('active')) {
          continue;
        } else if (isStepAlreadySet) {
          $thisBrief.addClass('skip-step-count');
          continue;
        }
        $thisBrief.addClass('step-added');
        $thisBenefitType = $thisBrief.find('.js-product-benefit-type');
        thisBenefitTypeText = $thisBrief.attr('data-benefit-type');
        thisBenefitHeader = $('.vto-skin-care-lux').attr('data-product-benefit-header') || 'Step';
        $thisBenefitType.text(thisBenefitHeader + ' ' + stepCount + ': ' + thisBenefitTypeText);
        $thisBenefitType.detach().prependTo($thisBrief);
        stepCount++;
      }
      updatePrice();
      updateImage();
    };

    $skinCareTabItemSimple.once().on('click', function () {
      $skinCareTabItemFull.removeClass('active');
      $(this).addClass('active');
      $elcVtoSkincareProductGrid.find('.js-product-brief').removeClass('active');
      $elcVtoSkincareProductGrid.find('.simple-regimen-product').addClass('active');
      arrangeBrief();
    });

    $skinCareTabItemFull.once().on('click', function () {
      $skinCareTabItemSimple.removeClass('active');
      $(this).addClass('active');
      $elcVtoSkincareProductGrid.find('.js-product-brief').addClass('active');
      arrangeBrief();
    });

    $skinCareTabItemSimple.trigger('click');

    if (isNutritious) {
      $skinCareResultNutritiousHeader.addClass('active');
      $('body').addClass('skincare-nutritious-product');
    } else {
      $skinCareResultNonNutritiousHeader.addClass('active');
    }

    $skinCareResultNonNutritiousHeader.find('.js-face-concern').text(selectedFaceConcernCopy.join(faceConcernSeparator));
    $skinCareResultNonNutritiousHeader.find('.js-eye-concern').text(selectedEyeConcernCopy);

    $('.js-skin-care-start-over').once().on('click', function () {
      window.history.pushState({}, document.title, window.location.pathname);
      $('body').removeClass('perfectionist-pro-added');
    });

    vtoProdResults.some((item) => perfectionistId.includes(item?.productId)) && $('body').addClass('perfectionist-pro-added');
  };
  const skincareResultOrdering = function () {
    var $skincareFormatter = $('.js-vto-skin-care-formatter');
    var resultProductsString = $('.js-elc-vto-skin-care', $skincareFormatter).attr('data-result-products');
    var resultProducts;

    if (!resultProductsString) {
      return;
    }
    resultProducts = JSON.parse(resultProductsString);

    $('.elc-vto-skincare-product-grid', $skincareFormatter).find('.js-product-brief').each(function () {
      var $this = $(this);
      var thisProductId = $this.attr('data-product-code');
      var thisIndex = resultProducts.indexOf(thisProductId);

      if (thisIndex > -1) {
        $this.parent('.js-grid-item-product').addClass('skincare-product-order--' + thisIndex);
      }
    });
  };
  const vtoSkinCareHook = function () {
    var $vtoSkincareCtaWrapper;
    var isVtoSkinCareLux = $('.js-vto-skin-care-screens').hasClass('vto-skin-care-lux');
    var $vtoSkinCareQuestionScreens = $();
    var $formItem = $();
    var $backLink = $();

    return {
      afterEmit: function (eventName) {
        if (Topics && Topics.events) {
          switch (eventName) {
            case Topics.events.VTO_SKIN_CARE_OPENED: {
              Drupal.behaviors.vtoSkinCareFormaterV1.toggleVtoSkinCareContainers(false);

              return;
            }
            case Topics.events.VTO_SKIN_CARE_CLOSED: {
              Drupal.behaviors.vtoSkinCareFormaterV1.toggleVtoSkinCareContainers(true);

              return;
            }
            case Topics.events.VTO_SKIN_CARE_RESULT_LOADED: {
              attachDrupalBehaviors();
              if (isVtoSkinCareLux) {
                handleSkinCareResults();
              } else {
                skincareResultOrdering();
              }

              return;
            }
            case Topics.events.VTO_SKIN_ANALYSIS_FINISHED: {
              $vtoSkincareCtaWrapper = $('.js-skin-care-result-cta-wrapper');
              $vtoSkinCareQuestionScreens = $('.skincare-question-screens');
              $formItem =  $vtoSkinCareQuestionScreens.find('.js-form-formatter__item');
              $backLink = $vtoSkinCareQuestionScreens.find('.js-back-link');
              if (isVtoSkinCareLux) {
                $('body').removeClass('hide-questions');
                if ($vtoSkinCareQuestionScreens.attr('data-active-field') === 'question_screen02') {
                  $backLink.trigger('click');
                }
                $formItem.find('.js-mantle-form__checkbox').removeClass('option-selected active options-unselected');
                $vtoSkinCareQuestionScreens.find('.js-mantle-cta-button').addClass('button--disabled');
                $vtoSkincareCtaWrapper.on('click', '.elc-skin-care-survey-cta', function () {
                  Drupal.behaviors.vtoSkinCareFormaterV1.toggleVtoSkinCareQuestions();
                });
                setupSkincareQuiz();
              }
            }
            case Topics.events.PRODUCT_SKU_SELECTED: {
              if (isVtoSkinCareLux) {
                updatePrice();
                updateImage();
              }
            }

            default: {
              break;
            }
          }
        }
      }
    };
  };
  const attachDrupalBehaviors = function () {
    Drupal.attachBehaviors('.js-skin-care-result-blocks');
  };

  ServiceBus.applyHook(vtoSkinCareHook);

  Drupal.behaviors.vtoSkinCareFormaterV1 = {
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.getDomNodes(context);
      self.nodes.$vtoSkinCareDisclaimerCheck.once().on('change', function() {
        self.toggleVtoSkinCareCheck();
      });
      self.nodes.$vtoSkinCareLandingCta.once().on('click', function () {
        self.handleSkinCareLandingCta();
        if ($('.js-vto-skin-care-screens').hasClass('vto-skin-care-lux')) {
          self.handleSkincareQuestionsSection();
        }
      });
      self.handleQRImg();
    },
    getDomNodes: function (context) {
      var self = this;

      self.nodes = {};
      self.nodes.$vtoSkinCareFormatter = $('.js-vto-skin-care-formatter', context);
      self.nodes.$vtoSkinCareScreens = $('.js-vto-skin-care-screens', self.nodes.$vtoSkinCareFormatter);
      self.nodes.$vtoSkinCareLandingCta = $('.js-vto-skin-care-landing-screen-cta', self.nodes.$vtoSkinCareFormatter);
      self.nodes.$vtoSkinCareScreen = $('.js-vto-skin-care-screen', self.nodes.$vtoSkinCareFormatter);
      self.nodes.$vtoSkinCareTipsScreen = $('.js-vto-skin-care-tips-screen', self.nodes.$vtoSkinCareFormatter);
      self.nodes.$vtoSkinCareLandingScreen = $('.js-vto-skin-care-landing-screen', self.nodes.$vtoSkinCareFormatter);
      self.nodes.$vtoSkinCareContainer = $('.js-elc-vto-skin-care', self.nodes.$vtoSkinCareFormatter);
      self.nodes.$vtoSkinCareDisclaimerCheck = $('.js-vto-skin-care-disclaimer-checkbox', self.nodes.$vtoSkinCareDisclaimerCheck);
    },
    handleSkinCareLandingCta: function () {
      var self = this;

      self.nodes.$vtoSkinCareTipsScreen.addClass('vto-skin-care-screens--active');
      self.nodes.$vtoSkinCareLandingScreen.removeClass('vto-skin-care-screens--active');
      self.nodes.$vtoSkinCareContainer.addClass('elc-vto-skin-care--active');
      self.trackSkincareCta();
    },
    handleSkincareQuestionsSection: function () {
      var $vtoSkinCareQuestionScreens = $('.skincare-question-screens');

      $vtoSkinCareQuestionScreens.find('.js-mantle-form-checkbox').removeClass('active option-selected');
      $vtoSkinCareQuestionScreens.find('.js-mantle-cta-button').addClass('button--disabled');
    },
    toggleVtoSkinCareContainers: function (isEnabled) {
      var self = this;

      if (isEnabled) {
        self.nodes.$vtoSkinCareLandingScreen.addClass('vto-skin-care-screens--active');
        self.nodes.$vtoSkinCareContainer.removeClass('elc-vto-skin-care--active');
      } else {
        self.nodes.$vtoSkinCareTipsScreen.removeClass('vto-skin-care-screens--active');
      }
    },

    toggleVtoSkinCareQuestions: function () {
      var self = this;
      var $vtoSkinCareQuestionScreens = $('.skincare-question-screens');

      self.nodes.$vtoSkinCareContainer.removeClass('elc-vto-skin-care--active');
      self.nodes.$vtoSkinCareContainer.siblings('.skincare-question-wrapper').removeClass('hidden');

      if ($vtoSkinCareQuestionScreens.attr('data-active-field') === 'question_screen02') {
        $('.js-back-link').trigger('click');
      }
      $vtoSkinCareQuestionScreens.find('.js-back-link').on('click', function () {
        $('.js-form-formatter__item').find('.js-mantle-form__checkbox').removeClass('option-selected active options-unselected');
      });
    },

    toggleVtoSkinCareCheck: function () {
      var self = this;
      var isDisclaimerChecked = $(self.nodes.$vtoSkinCareDisclaimerCheck).not(':checked').length === 0;

      self.nodes.$vtoSkinCareLandingCta.prop('disabled', !isDisclaimerChecked);
      self.nodes.$vtoSkinCareLandingCta.toggleClass('button--disabled', !isDisclaimerChecked);
      self.nodes.$vtoSkinCareLandingCta.toggleClass('button--dark', isDisclaimerChecked);
    },
    handleQRImg: function () {
      var self = this;
      var defaultlangId = self.nodes.$vtoSkinCareFormatter.attr('data-default-lang-id') || '';
      var showDefaultLangImg = defaultlangId === $('html').attr('lang');

      if (showDefaultLangImg) {
        $('body').addClass('show-default-lang-img');
      }
    },
    trackSkincareCta: function () {
      site.track.evtLink({
        site_type: 'event_based',
        event_name: 'vto',
        event_category: 'vto',
        event_action: 'started',
        vendor: 'youcam',
        vto_type: 'skincare'
      });
    },
    attached: false
  };
})(jQuery, window.GlobalServiceBus || {}, window.ServiceBusTopics || {});
